<template>
  <div>
    <!--Stats cards-->
    <div class="container-fluid d-flex flex-column col-12 align-items-center justify-content-center">
      <h2 class="text-center">Este sitio aún se encuentra en construcción...</h2>
      <div class="gif-background container col-6 rounded-circle">
        <img class="my-auto"
        :src="require('@/assets/img/working.gif')"
        alt="under construction"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CircleChartCard from "src/components/UIComponents/Cards/CircleChartCard.vue";
import ChartCard from "src/components/UIComponents/Cards/ChartCard";
import StatsCard from "src/components/UIComponents/Cards/StatsCard";
import BarChart from "src/components/UIComponents/Charts/BarChart";
import PPagination from "src/components/UIComponents/Pagination.vue";
import { Badge } from "src/components/UIComponents";
import Loading from "src/components/Dashboard/Layout/LoadingMainPanel.vue";
import axios from "axios";
import moment from "moment";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
} from "element-ui";
import Vue from "vue";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    StatsCard,
    ChartCard,
    CircleChartCard,
    Badge,
    Loading,
    PPagination,
    BarChart,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  computed: {},
  beforeMount() {
    this.$swal.close()
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
<style>
.gif-background {
  background-color: #2c2c2c;
  width: auto;
}
</style>
